const images = {
  logo_white: require('./images/Collect_White.png'),
  logo: require('./images/Collect.png'),
  toast: {
    info: require('./images/Toast_Info.svg').default,
    check: require('./images/Toast_Check.svg').default,
    error: require('./images/Toast_Error.svg').default,
    warning: require('./images/Toast_Alert.svg').default,
  },
  hamburger: require('./images/Hamburger.svg').default,
  navbar_close: require('./images/Navbar_Close.svg').default,
};

export default images;
